<div class="layout-row layout-align-start-center tr" (click)="onViewRouteTasks();$event.stopPropagation();">
  <!--Date-->
  <div class="td medium layout-row layout-align-start-center flex-15 text-ellipsis">
    <span class="br-body-1 font-weight-400 secondary-100">{{route.routeName}}</span>
  </div>

  <!--Missed Tasks-->
  <div class="td xsmall layout-row flex-10 text-ellipsis">
    <span class="br-body-1 font-weight-400 primary-100">{{route.missedTasks}}</span>
  </div>

  <!--Hours-->
  <div class="td xsmall layout-row flex-10 text-ellipsis">
    <span class="br-body-1 font-weight-400 primary-100">{{route.routeDuration | bringozTimeConvert }}</span>
  </div>

  <!--Start Time-->
  <div class="td xsmall layout-column flex-15 text-ellipsis">
    <div class="br-body-1 font-weight-600 layout-row layout-align-start-center"
         [ngbTooltip]="route.actualStartTime || geoEnterTime ?  actualStartTime : null" openDelay="300"
         triggers="hover"
         container="body"
         [ngClass]="{'green': !!geoEnterTime ? geoEnterTime?.timeStamp === route.plannedStartTime : route.actualStartTime === route.plannedStartTime,
               'red': geoEnterTime ?  geoEnterTime?.timeStamp !== route.plannedStartTime : route.actualStartTime !== route.plannedStartTime}">
      <span class="margin-right-5" translate>A</span>
      <span *ngIf="!geoEnterTime">{{route | bringozTime: 'actualStartTime'}}</span>
      <span *ngIf="!!geoEnterTime">{{geoEnterTime | bringozTime: 'timeStamp'}}</span>
    </div>
    <!--    <span class="margin-left-5 margin-right-5">/</span>-->

    <div class="br-body-1 font-weight-400 primary-100 layout-row layout-align-start-center margin-top-5"
         [ngbTooltip]="route.plannedStartTime?  plannedStartTime : null"
         openDelay="300"
         triggers="hover"
         container="body">
      <span class="margin-right-5" translate>PL</span>
      <span>{{route | bringozTime: 'plannedStartTime'}}</span>
    </div>

    <ng-template #actualStartTime>
      <span *ngIf="!geoEnterTime">{{route | bringozTime: 'actualStartTime'}} {{'Actual Start Time' | translate}}
        ({{'Manual' | translate}})</span>
      <span *ngIf="!!geoEnterTime">{{geoEnterTime | bringozTime: 'timeStamp'}} {{'Actual Start Time' | translate}}
        ({{'Passive' | translate}})</span>
    </ng-template>

    <ng-template #plannedStartTime>
      <span>{{route | bringozTime: 'plannedStartTime'}} {{'Planned Start Time' | translate}}</span>
    </ng-template>
  </div>

  <!--End Time-->
  <div class="td xsmall layout-column flex-15 text-ellipsis">
    <div class="br-body-1 font-weight-600 layout-row layout-align-start-center"
         [ngbTooltip]="route.actualEndTime || geoExitTime ? actualEndTime: undefined" openDelay="300"
         triggers="hover"
         container="body"
         [ngClass]="{'green': !!geoExitTime ? geoExitTime?.timeStamp === route.plannedEndTime : route.actualEndTime === route.plannedEndTime,
               'red': !!geoExitTime ?  geoExitTime?.timeStamp !== route.plannedEndTime : route.actualEndTime !== route.plannedEndTime}">
      <span class="margin-right-5" translate>A</span>
      <span *ngIf="!geoExitTime">{{route | bringozTime: 'actualEndTime'}}</span>
      <span *ngIf="!!geoExitTime">{{geoExitTime | bringozTime: 'timeStamp'}}</span>
    </div>
    <!--    <span class="margin-left-5 margin-right-5">/</span>-->

    <div class="br-body-1 font-weight-400 primary-100 layout-row layout-align-start-center margin-top-5"
         [ngbTooltip]="route.plannedEndTime ? plannedEndTime : undefined"
         openDelay="300"
         triggers="hover"
         container="body">
      <span class="margin-right-5" translate>PL</span>
      <span>{{route | bringozTime: 'plannedEndTime'}}</span>
    </div>

    <ng-template #actualEndTime>
      <span *ngIf="!geoExitTime">{{route | bringozTime: 'actualEndTime'}} {{'Actual End Time' | translate}}
        ({{'Manual' | translate}})</span>
      <span *ngIf="!!geoExitTime">{{geoExitTime | bringozTime: 'timeStamp'}} {{'Actual End Time' | translate}}
        ({{'Passive' | translate}})</span>
    </ng-template>

    <ng-template #plannedEndTime>
      <span>{{route | bringozTime: 'plannedEndTime'}} {{'Planned End Time' | translate}}</span>
    </ng-template>

  </div>

  <!--Sequence-->
  <div class="td large layout-row layout-align-start-center flex">
    <app-agent-sequence-score class="flex" [agentRouteScore]="route"></app-agent-sequence-score>
  </div>

  <!--Route Score-->
  <div class="td xsmall layout-row layout-align-start-center flex-5 text-ellipsis"
       [class.performance-metric]="route.routeScore >= 0"
       [class.good-score]="route.routeScore >= 80"
       [class.average-score]="route.routeScore > 60 && route.routeScore < 80"
       [class.bad-score]="route.routeScore <= 60">
    <span *ngIf="route.routeScore >= 0" class="br-body-1 font-weight-600">{{route.routeScore}} %</span>

  </div>

  <div class="td xxxsmall flex-5">
  </div>
</div>
